import { usePageTitleContext } from "context/PageTitleContext";

import styles from "./PageTitle.module.css";

const PageTitle = ({ title, desc }) => {
    const { title: contextTitle, desc: contextDesc } = usePageTitleContext();
    const resolvedTitle = title ?? contextTitle;
    const resolvedDesc = desc ?? contextDesc;

    return (
        <div className={styles.PageTitle} data-testid="page-title">
            <h1 className="text-2xl font-bold mb-4">{resolvedTitle}</h1>
            <p className="text-gray-600">{resolvedDesc}</p>
        </div>
    );
};

export default PageTitle;
